import { network } from 'services/network';
import { useMutation } from 'react-query';

const mutationFn = (params: QueryParams) => {
    const url = `api/bo/deleteCustomCluster?clusterId=${params}`;

    return network.post(url).then((response) => {
        return response.data;
    });
};
export const useMutationSavedSearchDelete = () => {
    return useMutation<unknown, QueryError, QueryParams>({
        mutationFn: (params) => mutationFn(params),
    });
};

type QueryParams = number | null;
